import { configureStore } from '@reduxjs/toolkit';
import CustomizerReducer from './customizer/CustomizerSlice';
// import ChatsReducer from './apps/chat/ChatSlice';
// import NotesReducer from './apps/notes/NotesSlice';
// import EmailReducer from './apps/email/EmailSlice';
// import TicketReducer from './apps/tickets/TicketSlice';
// import ContactsReducer from './apps/contacts/ContactSlice';
// import EcommerceReducer from './apps/eCommerce/EcommerceSlice';
// import UserProfileReducer from './apps/userProfile/UserProfileSlice';
// import CategoryReducer from './apps/category/CategorySlice';
// import BlogReducer from './apps/blog/BlogSlice';

// Auth
import authReducer from './apps/login/LoginSlice';

//Dashboard
import DashboardReducer from './apps/dashboard/DashboardSlice'

//Subscriber
import SubscriberReducer from './apps/subscriber/SubscriberSlice';

//Posts
import PostsReducer from './apps/posts/PostsSlice';

// Billing
import BillingReducer from './apps/billing/BillingSlice';
// Users List
import UserListReducer from './apps/userList/UserListSlice';

// Our slices

// import ProductListReducer from './apps/products/ProductsSlice';
// import CategoryUnitReducer from './apps/Helper/CategoryUnitSlice';
// import UnitReducer from './apps/unit/UnitSlice';
// import RoleReducer from './apps/roles/RolesSlice';
// import PermissionReducer from './apps/permissions/PermissionSlice';
// import CountryReducer from './apps/master/country/CountrySlice';
// import StateReducer from './apps/master/state/StateSlice';
// import CityReducer from './apps/master/city/CitySlice';
// import HelperReducer from './apps/Helper/HelperSlice';
// import NewProductReducer from './apps/newProductRequest/ProductRequestSlice';
// import OfferReducer from './apps/offers/OfferSlice';

// import PostReducer from './apps/posts/PostsSlice'
// import BannerReducer from './apps/banner/BannerSlice';
// import AppSettingReducer from './apps/setting/appSettingSlice';
// import FaqSettingReducer from './apps/setting/faqSettingSlice';


export const store = configureStore({
  reducer: {

    // Dashboard
    dashboardReducer : DashboardReducer,
    //subscriber
    subscriberReducer: SubscriberReducer,

    //post
    postsReducer:PostsReducer,

    // billing
    billingReducer: BillingReducer,

    customizer: CustomizerReducer,
    // chatReducer: ChatsReducer,
    // emailReducer: EmailReducer,
    // notesReducer: NotesReducer,
    // contactsReducer: ContactsReducer,
    // ticketReducer: TicketReducer,
    // ecommerceReducer: EcommerceReducer,
    // userpostsReducer: UserProfileReducer,
    // blogReducer: BlogReducer,

    // here calling our created slice
    auth: authReducer,
    userReducer: UserListReducer,
    // productReducer: ProductListReducer,
    // categoryUnitReducer: CategoryUnitReducer,
    // unitReducer: UnitReducer,
    // roleReducer: RoleReducer,
    // permissionReducer: PermissionReducer,
    // categoryReducer: CategoryReducer,
    // countryReducer: CountryReducer,
    // stateReducer: StateReducer,
    // cityReducer: CityReducer,
    // productRequestReducer: NewProductReducer,
    // offerReducer: OfferReducer,
    
    // postReducer: PostReducer,
    // bannerReducer: BannerReducer,

    // // Settings
    // appSettingReducer: AppSettingReducer,
    // faqSettingReducer: FaqSettingReducer,

    // // Helper
    // helperReducer: HelperReducer,
  },
});

export default store;
